<script setup lang="ts">

import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import { EVENT_NAMES } from '@/tracking/analytics/event_names.ts'

interface CustomClipboardEvent extends ClipboardEvent {
  detail?: {
    fromButton?: boolean;
    stringToCopy?: string;
  };
}

const props = defineProps({
  type: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  uuid: {
    type: String,
    default: ''
  },
  level: {
    type: String,
    default: ''
  }
})

const analytics = getAnalyticsTracker()

function truncateText(text: string) {
    let truncatedText = text
    let words = text.split(' ')
    if (words.length > 40) {
      truncatedText = words
        .slice(0, 40)
        .concat([`...(${words.length - 40} more words)`])
        .join(' ')
    }
    return truncatedText
}

import { getClipboardText } from '@/util/copypaste_helpers'

function captureCopy(evt: CustomClipboardEvent) {
  const text = evt.detail?.stringToCopy ?? getClipboardText('')
  analytics.sendEvent(EVENT_NAMES.MISC.COPIED_TEXT, {
    copied_text_type: props.type,
    copied_text_text: truncateText(text),
    copied_text_title: props.title,
    copied_text_uuid: props.uuid,
    copied_text_level: props.level,
    from_button: !!(evt.detail && evt.detail.fromButton),
  })
}
</script>

<template>
<div @copy="captureCopy"><slot></slot></div>
</template>